<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>


<div style="margin-top: 5rem;">
    <mat-accordion class="mt-5 mb-5">
        <mat-expansion-panel [expanded]="expanded" (afterExpand)="expanded = !expanded" style="overflow: visible;">
            <mat-expansion-panel-header class="bg-header" [collapsedHeight]="'30px'" [expandedHeight]="'30px'">
                <mat-panel-title class="panel-title">My Profile</mat-panel-title>
            </mat-expansion-panel-header>


            <form [formGroup]="myProfileForm" (ngSubmit)="getMyProfiles($event)">
                <div class="row d-flex justify-content-between">
                    <div class="col-5 ml-5">
                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="text-left col-4 field-name-margin">Gender</p>
                            <mat-radio-group class="col-8 p-0 d-flex" formControlName="gender">
                                <mat-radio-button class="arrival-date-type" [value]="1">Male</mat-radio-button>
                                <mat-radio-button class="arrival-date-type" [value]="2">Female</mat-radio-button>
                                <mat-radio-button [value]="0">Both</mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="text-left col-4 field-name-margin">Profile ID</p>
                            <div class="col-8 p-0">
                                <input type="text" formControlName="profileID" class="form-control"
                                (change)="onChange($event)" placeholder="Enter Profile ID">
                            <div *ngIf="myProfileForm.controls['profileID'].errors && !myProfileForm.controls['profileID'].pristine"
                                class="error-msg1">
                                <div [hidden]="!myProfileForm.controls['profileID'].errors.pattern">
                                    Enter Valid Profile ID!
                                </div>
                            </div>
                            </div>
                           
                        </div>

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Application Status</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Application Status'" [settings]="multiDropdownSettings"
                                [data]="applicationStatus" formControlName="applicationStatus" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                        </div>

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Branch</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Branch'" [settings]="multiDropdownSettings"
                                [data]="branchList" (onSelect)="onBranchItemSelect($event)"
                                (onDeSelect)="onBranchItemDeSelect($event)" formControlName="branch"
                                (onSelectAll)="onBrachItemsSelectAll($event)"
                                (onDeSelectAll)="onBranchDeSelectAll($event)" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                        </div>

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Primary Owner</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Primary Owner'" [settings]="multiDropdownSettings"
                                [data]="owner" formControlName="profileOwner" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                        </div>
                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4 new-field">Secondary Owner</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Secondary Owner'" [settings]="multiDropdownSettings" [data]="owner"
                                formControlName="secondaryOwner" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                        </div> 
                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Previous Owner</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Previous Owner'" [settings]="multiDropdownSettings"
                                [data]="owner" formControlName="previousOwner" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                        </div>
                         


                        <div class="inputBox row mt-3 mb-3 customMultiSelect"  *ngIf="loginData?.isManagement === 1 || loginData?.isAdmin === 1">
                            <p class="field-name-margin col-4">Payment from</p>
                            <input matInput [matDatepicker]="paymentFrom" [max]="maxDate" class="form-control col-8 ka-disabled"
                            placeholder="Payment From Date" formControlName="paymentFrom">
                            <mat-datepicker-toggle matSuffix [for]="paymentFrom"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['paymentFrom'].value" matSuffix (click)="clearDate('paymentFrom')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #paymentFrom></mat-datepicker>
                        </div>

                        <!-- <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Assigned From</p>
                            <input matInput [matDatepicker]="assignFrom" [max]="maxDate" class="form-control col-8 ka-disabled"
                                placeholder="Assign From Date" formControlName="assignedFrom">
                            <mat-datepicker-toggle matSuffix [for]="assignFrom"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['assignedFrom'].value" matSuffix
                                (click)="clearDate('assignedFrom')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #assignFrom></mat-datepicker>
                        </div> -->
                        <div class="inputBox row mt-3 mb-3 customMultiSelect" >
                            <p class="field-name-margin col-4">Created From</p>
                            <input matInput [matDatepicker]="picker" [max]="maxDate"
                                class="form-control col-8 ka-disabled" placeholder="Created From Date"
                                formControlName="dateOfRegFrom">
                            <mat-datepicker-toggle matSuffix [for]="picker"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['dateOfRegFrom'].value" matSuffix
                                (click)="clearDate('dateOfRegFrom')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>

                        
                            <div class="inputBox row mt-3 mb-3 customMultiSelect">
                                <p class="text-left col-4  field-name-margin">Name</p>
                                <div class="col-8 p-0">
                                    <input type="text" formControlName="firstName" class="form-control" placeholder="Enter Name">
                                    <div *ngIf="myProfileForm.controls['firstName'].errors && !myProfileForm.controls['firstName'].pristine"
                                        class="error-msg1">
                                        <div [hidden]="!myProfileForm.controls['firstName'].errors.pattern">
                                            Enter Valid Name
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="text-left field-name-margin col-4">Father Name</p>
                            <div class="col-8 p-0">
                                <input type="text" formControlName="fatherName" class="form-control" placeholder="Enter Father Name">
                                <div *ngIf="myProfileForm.controls['fatherName'].errors && !myProfileForm.controls['fatherName'].pristine"
                                    class="error-msg1">
                                    <div [hidden]="!myProfileForm.controls['fatherName'].errors.pattern">
                                        Enter Valid Father Name
                                    </div>
                                </div>
                            </div>
                           
                        </div>


                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="text-left col-4 field-name-margin">Profiles Logged In Website</p>
                            <mat-radio-group formControlName="logoutId" class="col-8 p-0 d-flex">
                                <mat-radio-button class="arrival-date-type" [value]="1">Yes</mat-radio-button>
                                <mat-radio-button class="arrival-date-type" [value]="2">No</mat-radio-button>
                                <mat-radio-button [value]="">Both</mat-radio-button>
                            </mat-radio-group>
                        </div>






                        


                    </div>
                    <div class="col-5 mr-5">                        
                            <div class="inputBox row mt-3 mb-4 customMultiSelect">
                                <p class="text-left col-4 field-name-margin">Type of Profile</p>
                                <div class="col-8 p-0">
                                    <mat-radio-group  class="p-0 d-flex" formControlName="typeOfProfile">
                                        <mat-radio-button class="arrival-date-type" [value]="1">Paid</mat-radio-button>
                                        <mat-radio-button class="arrival-date-type" [value]="0">Unpaid</mat-radio-button>
                                        <mat-radio-button [value]="">Both</mat-radio-button>
                                    </mat-radio-group>
                                   
                                </div>                              
                            </div>                        
                   
                   
                        <div class="inputBox row mt-3 mb-4 customMultiSelect">
                            <p class="text-left col-4 field-name-margin">Domicile</p>
                            <mat-radio-group formControlName="domacile" class="col-8 p-0 d-flex ">
                                <mat-radio-button class="arrival-date-type" [value]="1">India</mat-radio-button>
                                <mat-radio-button class="arrival-date-type" [value]="2">Abroad</mat-radio-button>
                                <mat-radio-button [value]="">Both</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin new-field col-4">Education Category</p>
                            <ng-multiselect-dropdown [placeholder]="'Select Education Category'" [settings]="multiDropdownSettings" [data]="educationCategories"
                              formControlName="educationCategory" class="col-8 ka-myProfile-multiSelect">
                            </ng-multiselect-dropdown>
                          </div>

                        
             
                    <div class="inputBox row mt-3 mb-3 customMultiSelect">
                        <p class="field-name-margin col-4">Marital Status</p>
                        <ng-multiselect-dropdown [placeholder]="'Select Marital Status'" [settings]="multiDropdownSettings"
                            [data]="marital" formControlName="marital" class="col-8 ka-myProfile-multiSelect">
                        </ng-multiselect-dropdown>
                    </div>
                    
               
                    <div class="inputBox row mt-3 mb-3 customMultiSelect">
                        <p class="field-name-margin col-4">Caste</p>
                        <ng-multiselect-dropdown [placeholder]="'Select Caste'" [settings]="multiDropdownSettings" [data]="caste"
                            formControlName="caste" class="col-8 ka-myProfile-multiSelect">
                        </ng-multiselect-dropdown>
                    </div>
                  
                    <div class="inputBox row mt-3 mb-2 customMultiSelect">
                        <p class="field-name-margin col-4">Having Profiles</p>
                        <ng-multiselect-dropdown [placeholder]="'Select Having Profiles'" [settings]="multiDropdownSettings"
                            [data]="havingProfiles" formControlName="havingProfile" class="col-8 ka-myProfile-multiSelect">
                        </ng-multiselect-dropdown>
                    </div>
                    <div class="row ka-myprofile-checkbox px-3">
                        <div>
                            <mat-checkbox formControlName="renewal" class="arrival-date-type mr-0">Renewal</mat-checkbox>
                            <mat-checkbox formControlName="chkKmplexperiry" class="arrival-date-type ml-3 pl-4">Expiry</mat-checkbox>
                        </div>

                        <div class="ka-myprofile-checkbox2 customMultiSelect">
                            <mat-checkbox (change)="openGradeSelection($event)" formControlName="confidential"
                                class="arrival-date-type">Confidential</mat-checkbox>
                            <mat-checkbox *ngIf="loginData?.isManagement === 1" formControlName="highConfidential" class="ml-3">Super Confidential
                            </mat-checkbox>
                            <mat-checkbox *ngIf="loginData?.isSuperHighConfidential === 1" formControlName="nxGradeProfiles" class="ml-3">NX-Profiles</mat-checkbox>
                        </div>    
                        <div class="inputBox row mt-3 mb-2 customMultiSelect" *ngIf="confiGrade">
                            <p class="field-name-margin col-4">Confidential Grade(New)</p>
                              <ng-multiselect-dropdown [placeholder]="'Select Confidential Grade(New)'" [settings]="multiDropdownSettings"
                                [data]="confidentialGrades" formControlName="confidentialGrade" class="col-8 ka-myProfile-multiSelect">
                              </ng-multiselect-dropdown>
                        </div>              
                    </div>
                    

                        <div class="inputBox row mt-3 mb-3 customMultiSelect"  *ngIf="loginData?.isManagement === 1 || loginData?.isAdmin === 1">
                            <p class="field-name-margin col-4">Payment to</p>
                            <input matInput [matDatepicker]="paymentTo" [max]="maxDate"
                                class="form-control col-8 ka-disabled" placeholder="Payment To Date"
                                formControlName="paymentTo">
                            <mat-datepicker-toggle matSuffix [for]="paymentTo"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['paymentTo'].value" matSuffix (click)="clearDate('paymentTo')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #paymentTo></mat-datepicker>
                        </div>

                        <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Created To</p>
                            <input matInput [matDatepicker]="picker1" [max]="maxDate" class="form-control col-8 ka-disabled"
                                placeholder="Created To Date" formControlName="dateOfRegTo">
                            <mat-datepicker-toggle matSuffix [for]="picker1"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['dateOfRegTo'].value" matSuffix
                                (click)="clearDate('dateOfRegTo')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </div>

                        <!-- <div class="inputBox row mt-3 mb-3 customMultiSelect">
                            <p class="field-name-margin col-4">Assigned To</p>
                            <input matInput [matDatepicker]="assignTo" [max]="maxDate" class="form-control col-8 ka-disabled"
                                placeholder="Assign To Date" formControlName="assignedTo">
                            <mat-datepicker-toggle matSuffix [for]="assignTo"
                                style="position: absolute;margin-left: 92%;margin-top: -11px;"></mat-datepicker-toggle>
                            <mat-datepicker-toggle class="clear"
                                style="position: absolute;margin-left: 85%;margin-top: -11px;"
                                *ngIf="myProfileForm.controls['assignedTo'].value" matSuffix
                                (click)="clearDate('assignedTo')">
                                <mat-icon matDatepickerToggleIcon><i class="fa fa-times"></i></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #assignTo></mat-datepicker>
                        </div> -->
                        
                            <div class="inputBox row mt-3 mb-3 customMultiSelect">
                                <p class="text-left col-4 field-name-margin">Surname</p>
                                <div class="col-8 p-0">
                                    <input type="text" formControlName="surName" class="form-control" placeholder="Enter Surname">
                                    <div *ngIf="myProfileForm.controls['surName'].errors && !myProfileForm.controls['surName'].pristine"
                                        class="error-msg1">
                                        <div [hidden]="!myProfileForm.controls['surName'].errors.pattern">
                                            Enter Valid Surname
                                        </div>
                                    </div>
                                </div>
                               
                            </div>

                            <div class="inputBox row mt-3 mb-3 customMultiSelect">
                                <p class="text-left col-4 field-name-margin">Mother Name</p>
                                <div class="col-8 p-0">
                                    <input type="text" formControlName="motherName" class="form-control" placeholder="Enter Mother Name">
                                    <div *ngIf="myProfileForm.controls['motherName'].errors && !myProfileForm.controls['motherName'].pristine"
                                        class="error-msg1">
                                        <div [hidden]="!myProfileForm.controls['motherName'].errors.pattern">
                                            Enter Valid Mother Name
                                        </div>
                                    </div>
                                </div>
                              
                            </div>
                            <!-- <div class="inputBox row mt-3 mb-4 customMultiSelect" *ngIf="loginData['isSuperAdmin']">
                                <p class="text-left col-4 field-name-margin">Confidential Profiles</p>
                                <mat-radio-group formControlName="Nconfidential" class="col-8 p-0 d-flex ">
                                    <mat-radio-button class="arrival-date-type" [value]="1">My Confidential Profiles</mat-radio-button>
                                    <mat-radio-button class="arrival-date-type" [value]="0">Alloted Profiles</mat-radio-button>
                                    <mat-radio-button class="arrival-date-type" [value]="null">None</mat-radio-button>                                    
                                </mat-radio-group>
                            </div> -->
                          
                                        
                    </div>

                <div class="col-md-12 typeHolder">
                    <div class="typeSection" >
                        <!-- <mat-radio-group >
                            <mat-radio-button class="typeOfView" [value]="1">Grid View</mat-radio-button>
                            
                            <mat-radio-button class="typeOfView" [value]="0">Slide Show</mat-radio-button>
                        </mat-radio-group> -->                        
                        <button  class=" m-2 ka-myProfile-viewType" (click)="slideOrGrid('grid')"  mdbWavesEffect type="submit"> GRID </button>
                        <button type="button" (click)="reset()" class=" m-2 reset-btn">RESET</button>      
                        <button   class=" m-2 ka-myProfile-viewType" (click)="slideOrGrid('slide')"  mdbWavesEffect type="submit"> SLIDE SHOW </button>                  
                        
                    </div>
                </div>
            </div>
            </form>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="profile-grid mt-5">
        <app-grid *ngIf="myProfiles?.length > 0" [data]="myProfiles" [formValue]="formValue" [type]="gridType2"
            [defaultColumns]="headers" [matchedHeaders]="matchedHeaders" [multiSelectItems]="totalFields"
            [selectedItems]="matchedHeaders" [myProfile]="myProfile" [scrollDown]="scrollDown" [myProfiles]="myProfiles"
             [myProfileGrid]="myProfileGrid" [reqObj]="myProfileReqObj" [display]="myProfiles" >
        </app-grid>
        <div class="lst-loadmore-container" *ngIf="lastvalue?.Row != lastvalue?.totalRows && !loadedAllData">
            <span (click)="loadMore()" class="lst-loadmore">Load More</span>
        </div>
        <div class="no-records" [hidden]="myProfiles?.length !== 0">
            No Records Found
        </div>
    </div>
</div>

<div mdbModal #alertModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="alertModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="alertModal.hide()">ok
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>